import { useUsersStore } from 'src/stores/index.js'
import _ from 'lodash'

export default {
  keyedById: (state) => _.keyBy(state.forms, 'id'),
  getFormsByCalendar: (state) => {
    const usersStore = useUsersStore()
    if (usersStore.currentIsAdmin) {
      return state.forms.filter(form => form.assignment.by_calendar && form.assignment.published)
    } else {
      return state.forms.filter(form => form.assignment.by_calendar && form.assignment.published && form.assignment.self_manage)
    }
  },
  getFormName: (state) => form_id => {
    if (Array.isArray(form_id)) {
      if (state.forms.length > 0) {
        let title = state.forms.find(form => form.id === form_id[0]).name_label
        form_id.forEach((f_id, i) => {
          if (i > 0) {
            title = `${title}, ${state.forms.find(form => form.id === f_id).name_label}`
          }
        })
        return title
      }
    } else {
      if (state.forms.length > 0) return state.forms.find(form => form.id === form_id).name_label
      return ''
    }
  }
}
